import VueApexCharts from 'vue-apexcharts'
import moment from 'moment-timezone'
import codes from '@/f1/codes'

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  reload: {
    EN : `Saved! , reload 3 sec later`,
    KO : `저장 성공!, 3초 후 페이지가 새로고침됩니다`,
  },
  load : {
    EN : `load Successful`,
    KO : '데이터 불러오기 성공',

  },
  page_total : {
    EN : `all pages`,
    KO : '점검 대상 모든 페이지',
  },
  page : {
    EN : `Pages on the site`,
    KO : '점검 사이트의 페이지',
  },
  ext : {
    EN : `External page`,
    KO : '외부 페이지',
  },
  detect : {
    EN : `Detect page`,
    KO : '탐지 페이지',
  },
  binary : {
    EN : `Binary page`,
    KO : '바이너리 페이지',
  },
  resource : {
    EN : `Resource page`,
    KO : '리소스 페이지',
  },
  error : {
    EN : `Error page`,
    KO : '에러 페이지',
  },
  copied : {
    EN : "ticket copied for QNA",
    KO : "점검 번호가 복사되었습니다"
  },
  copy_failed : {
    EN : "ticket copied for QNA",
    KO : "작업 번호가 복사되었습니다"
  },
  inspection_failed : {
    EN : "inspection failed",
    KO : "점검 실패"
  }
};

export default {
  props: ['status', 'refresh_timer'],
  components: { VueApexCharts },
  watch : {
    status() {
      this.get()
    }
  },
  data : () => {
    return {
      codes,
      moment,
      total : 0,
      thumbnail_size: '100%',
      data_resource: [],
      options_resource: {
        labels: [],
        legend: { position: 'bottom', }
      },
      data_site: [],
      options_site: {
        labels: [],
        legend: { position: 'bottom', }
      },
      result : {},
      tmp_site : {},
      tmp_resource : {},
    }
  },

  computed: {
    i18n_data() { return _i18n_data; },
  },
  methods: {
    copy(task_key, page) {
      try {
        var tempElem = document.createElement('textarea');
        tempElem.value =`${task_key}|${page}`;
        document.body.appendChild(tempElem);
        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);

        this.$toastr.i(this.i18n_data['copied'][this.i18n])

      } catch (e) { console.log(e); this.$toastr.i(this.i18n_data['copy_failed'][this.i18n]) }
    },
    get() {
      try {
        this.result = Object.assign({}, this.result, this.status)
        this.total = 0
        this.data_resource = []
        this.data_site = []
        this.options_resource = Object.assign({}, { labels : [] })
        this.options_site = Object.assign({}, { labels : [] })

        Object.keys(this.result).forEach(x => {
          try {

            let key = x.replace("_qty", '')
            if(x.endsWith("_qty")) {
              this.tmp_site[key] = this.result[x]
              this.total += this.result[x]
            }
          } catch (e) { console.error(e) }
        })

        // site
        this.data_site.push(this.tmp_site.page - this.tmp_site.external)
        this.options_site.labels.push(this.i18n_data['page'][this.i18n])

        this.data_site.push(this.tmp_site.broken)
        this.options_site.labels.push(this.i18n_data['error'][this.i18n])

        this.data_site.push(this.tmp_site.external)
        this.options_site.labels.push(this.i18n_data['ext'][this.i18n])

        this.data_site.push(this.tmp_site.detect)
        this.options_site.labels.push(this.i18n_data['detect'][this.i18n])

        // resource
        this.data_resource.push(this.tmp_site.page - this.tmp_site.external)
        this.options_resource.labels.push(this.i18n_data['page'][this.i18n])

        this.data_resource.push(this.tmp_site.resource)
        this.options_resource.labels.push(this.i18n_data['resource'][this.i18n])

        if(this.total < 1) {
          this.data_site.push(100)
          this.data_resource.push(100)
          this.options_resource.labels.push(this.i18n_data['inspection_failed'][this.i18n])
          this.options_site.labels.push(this.i18n_data['inspection_failed'][this.i18n])
        }

        this.$toastr.s(this.i18n_data['load'][this.i18n])
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
  },
  // watch: { '$route' (to, from) { console.log("from", from) } },
  created() { console.log('result.detail.vue', 'created'); },
  destroyed() { console.log('result.detail.vue', 'destroyed'); },
  mounted() { console.log('result.detail.vue', 'mounted'); this.get(); },
}
